import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import DetailLine from 'modules/payroll_bundle/pages/IncidenceDetailPage/_DetailLine'

interface LeaveInfoLineProps {
  label: string
  oldValue: string | null | undefined
  newValue: string
}

const LeaveInfoLine = ({ label, oldValue, newValue }: LeaveInfoLineProps) => {
  const hasOldValueAndHasChanged = oldValue !== undefined && oldValue !== newValue

  return (
    <>
      {hasOldValueAndHasChanged ? (
        <IncidenceDetailDataChangeLine label={label} oldValue={oldValue} newValue={newValue} />
      ) : (
        <DetailLine component="li" title={label} value={newValue} />
      )}
    </>
  )
}

export default LeaveInfoLine
